// Valid panel types for VideoPanel component
export const VideoPanelTypes = {
  DETAILS: 'DETAILS',
  PICKER: 'PICKER'
};
export const PanelTypes = Object.assign({}, VideoPanelTypes, {
  CLIP_EDITOR: 'CLIP_EDITOR'
});
export const DetailsTabs = {
  OPTIMIZATION: 'OPTIMIZATION',
  PERFORMANCE: 'PERFORMANCE',
  CAPTIONS: 'CAPTIONS',
  DETAILS: 'DETAILS',
  VARIANTS: 'VARIANTS'
};